module.exports = __webpack_public_path__ + "static/media/3.d7f882a9.JPG";